import {ChangeEvent, useRef} from "react";
import {TImageCompressorProps} from "@/app/[locale]/common/components/ImageCompressor/types";

export const ImageCompressor = ({ handleFileChange }: TImageCompressorProps) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    const handleImageUpload = async (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const reader = new FileReader();  // позволяет асинхронно читать сожержимое файлов
        reader.onload = (e) => {  // срабатывает когда файл успешно прочитан
            const img = new Image();   // создаю img
            img.onload = () => {
                const canvas = canvasRef.current;
                if (!canvas) return;
                const ctx = canvas.getContext("2d");  // создаю канвас холст 2д

                const maxWidth = 800;
                const maxHeight = 800;

                let width = img.width;
                let height = img.height;

                // Масштабируем изображение до заданных размеров
                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                ctx?.drawImage(img, 0, 0, width, height); // накладываю img на холст, 2-3 параметр- координаты

                // Сжимаем изображение и экспортируем
                canvas.toBlob(
                    async (blob) => {
                        console.log(`Original size: ${(file.size / 1024).toFixed(2)} KB`);
                        console.log(blob ? `Compressed size: ${(blob.size / 1024).toFixed(2)} KB` : 'Compressed size - error');

                        // Отправляем уменьшенное изображение на сервер
                        const base64 = await convertBlobToBase64(blob as Blob);

                        await handleFileChange(base64);
                    },
                    "image/jpeg", // тип, можно выбрать другие типы
                    0.7  // снижаю качество
                );
            };
            img.src = e.target?.result as string;
        };
        reader.readAsDataURL(file);
    };

    const convertBlobToBase64 = (blob: Blob): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result as string);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(blob);
        });
    };

    return (
        <>
            <input type={'file'} accept="image/*" onChange={handleImageUpload} />
            <canvas ref={canvasRef} style={{ width: '100px', height: '50px' }} />
        </>
    );
};